<script setup lang="ts">
import { LoadStatus } from "@/models/frontend-only/LoadStatus";

const store = useSongStore();
const song = computed(() => store.data);

const shown = computed(() => {
  if (
    store.status === LoadStatus.Ready &&
    store.song?.products.general.authorized &&
    !store.song?.administrators?.length
  ) {
    return false;
  }
  return true;
});
</script>

<template>
  <section v-if="shown">
    <SectionTitle :placeholder="store.placeholderNotLoaded">{{
      $t("G.LIT_Administrators")
    }}</SectionTitle>
    <div
      v-if="store.placeholderNotAuthorized"
      :class="{ 'placeholder-glow': store.loading }"
    >
      <Placeholder
        :lines="2"
        full-width
      />
    </div>
    <div v-else-if="song?.administrators">
      {{ song.administrators.join(", ") }}
    </div>
  </section>
</template>

<style scoped lang="postcss"></style>
